<div data-test="iOdsWhhM" class="calendar-header d-flex justify-content-between p-4">
  <div data-test="OwJdcBSB" class="left-side">
    <h1 data-test="1eQ7ANKz"><ng-content select="[title]"></ng-content></h1>
  </div>
  <div data-test="4Jyup-CJ" class="right-side d-flex align-items-center">
    <ui-kit-button
      *ngIf="!hideAddEventButton"
      data-test="-lJaPKq8"
      class="new-entry-btn"
      [theme]="{ color: 'primary', shape: 'floating' }"
      (click)="addNewEntry.emit()"
    >
      <i data-test="FNb0RHnT" class="material-icons">add</i>
      <span data-test="ArtH3ira" class="button__hover">New entry</span>
    </ui-kit-button>
    <div data-test="8FZOMKdf" class="tabs-switch tabs-switch_light" *mdAutorun>
      <div
        data-test="4NLyMrOf"
        *ngFor="let tab of viewTabs"
        [class.active]="activeView === tab.view"
        (click)="changeView.emit(tab.view)"
        class="tabs-switch__item"
      >
        <span data-test="IZGHnv_W">{{ tab.label }}</span>
      </div>
    </div>

    <div data-test="IioSQk_0" class="date-switch" *mdAutorun>
      <button
        data-test="BjBbc2Uw"
        (click)="goPrevious.emit()"
        class="date-switch__button date-switch__button-prev"
      >
        <i data-test="MWXpLJMk" class="material-icons md-16">keyboard_arrow_left</i>
      </button>
      <button
        data-test="2c412T0Q"
        (click)="goTodayOrThisWeek.emit()"
        [disabled]="
          activeView === TimeTrackerViews.DAY ? todaySelected : thisWeekSelected
        "
        class="date-switch__text"
      >
        {{
          activeView === TimeTrackerViews.DAY
            ? 'Today'
            : activeView === TimeTrackerViews.WEEK
            ? 'This Week'
            : 'This Month'
        }}
      </button>
      <button
        data-test="EKO4jxpp"
        (click)="goNext.emit()"
        class="date-switch__button date-switch__button-next"
      >
        <i data-test="o2J1kY7H" class="material-icons md-16">keyboard_arrow_right</i>
      </button>
    </div>

    <button
      data-test="guEWNAqV"
      class="close d-flex align-items-center justify-content-center"
      data-dismiss="modal"
      type="button"
      (click)="closeHandler.emit()"
    >
      <span
        data-test="gu8LLiUN"
        class="close-badge d-flex align-items-center justify-content-center"
      >
        <i data-test="Nx3gB2OS" class="material-icons">close</i>
      </span>
    </button>
  </div>
</div>
